export const emailConfirmationConfig = {
    title: 'Confirme sua conta!',
    paragraph: 'Agora é só abrir seu e-mail para confirmar a sua conta e conquistar a vaga que tem a sua cara!',
    buttonLabel: 'Vou confirmar minha conta já!'
}